export function jsDetect()
{
	document.documentElement.classList.replace('no-js', 'js');
}